var o = {
  ceil: Math.ceil,
  round: Math.round,
  floor: Math.floor,
  trunc: function(n) {
    return n < 0 ? Math.ceil(n) : Math.floor(n);
  }
  // Math.trunc is not supported by IE
}, r = "trunc";
function t(n) {
  return n ? o[n] : o[r];
}
export {
  t as getRoundingMethod
};
//# sourceMappingURL=index330.mjs.map
